export default "__VITE_ASSET__BR1Mc6TD__"